import { FractalExplorer } from './app/FractalExplorer.js';

new FractalExplorer();
